// @flow
import * as React from 'react';
import s from './ConfirmLeaveModal.scss';

type Props = {
  onClick: (confirm: boolean) => void,
  header: string,
  body: string,
  visible: boolean,
  label1: string,
  label2: string,
}

export const ConfirmLeaveModal = (props: Props) => {
  const { onClick, header, body, visible, label1, label2 } = props
  return (
    <div style={{display: visible ? 'block': 'none'}}>
      <div className={s.modal}>
        {/* <span
          onClick={() => setModal(-1, '')}
          className={s.close_btn}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </span> */}
        <div className={s.body}>
          <div className={s.text_container}>
            <h4 className={s.header}>{header}</h4>
            <p>{body}</p>
          </div>
        </div>
        <div className={s.btn_container}>
          <button
            className={s.submit_btn}
            onClick={() => onClick(true) }
          >
            {label1}
          </button>
          <button
            className={s.submit_btn}
            onClick={() => onClick(false) }
          >
            {label2}
          </button>
        </div>
      </div>
      <div
        className={s.modal_bg}
        onClick={() => onClick(false) }
      >
      </div>
    </div>
  )

}

export default ConfirmLeaveModal
